export const isE2E = typeof window !== 'undefined' && window.isE2E === true;
